// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1J2m9","title":"ClientReferral_title__2mRab","itemText":"ClientReferral_itemText__nfaU_"};